/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Camera_ErrorInputs */

const vi_qr_camera_error = /** @type {(inputs: Qr_Camera_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể truy cập camera. Dùng nhập tay bên dưới.`)
};

/**

* @param {Qr_Camera_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_camera_error = /** @type {((inputs?: Qr_Camera_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Camera_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_camera_error(inputs)
});